var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('loader',{staticStyle:{"height":"100vh"}}):[(_vm.$route.name !== 'page-404')?_c('navbar'):_vm._e(),_c('router-view'),(_vm.$route.name !== 'page-404')?_c('v-footer'):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }